import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { clientMessage } from '../../utils/common';
import { PAYMENT_FLOW, PAYMODE } from '../../../../common/src/constant';

class WalletLogin extends Component {
  render({ wallet, insufficientBalance }) {
    const paymentOptions = this.props.cache.getData('paymentOptions');
    const locale = clientMessage(PAYMODE.WALLET.toLowerCase(), this.props.cache);
    this.label = locale.label;
    return (
      <div className={`ptm-pay-method-cont`} id="checkout-wallet-login">
        <p className={`ptm-paymode-name`}>{wallet.displayName}</p>
        <p className={`ptm-small-txt`}>
          Available Balance Rs {wallet.walletBalance ? wallet.walletBalance : 0}
          {/* <img */}
          {/*  className={`${style['dropdown']}`} */}
          {/*  src={`${staticPath()}/assets/images/ic-dropdown-light.svg`} */}
          {/* /> */}
        </p>
        {insufficientBalance &&
          (paymentOptions.paymentFlow === PAYMENT_FLOW.ADDANDPAY ||
            paymentOptions.paymentFlow === PAYMENT_FLOW.NONE) && (
            <p className="ptm-small-txt ptm-msg-red ptm-insufficient-balance">
              {this.label.insufficientBalance}
            </p>
          )}
        {!wallet.isEnabled && (
          <p className="ptm-small-txt ptm-msg-red ptm-disabled-msg">{wallet.disableMsg}</p>
        )}
      </div>
    );
  }
}

export default connect('cache')(WalletLogin);



// WEBPACK FOOTER //
// ./components/wallet/WalletLogin.js